import { useEffect, useState } from 'react';
import { deepEqual } from '@utils/object';

export default function useForm(callback: any, validate: (values: any) => any, initialValues?: any, dontValidate?: boolean) {
  const [values, setValues] = useState<any>(initialValues || {});
  const [latestInitialValue, setLatestInitialValue] = useState();
  const [errors, setErrors] = useState<any>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // if initial values are not ready when first called. e.g. AccountUserDetailsForm
  useEffect(() => {
    if ((!latestInitialValue && initialValues) || !deepEqual(latestInitialValue, initialValues)) {
      setLatestInitialValue(initialValues);
      setValues(initialValues);
    }
  }, [initialValues]);

  async function handleSubmit(e?: React.FormEvent) {
    if (e) e.preventDefault();
    if (isSubmitting) return;

    const newErrors = validate(values);

    if (dontValidate) {
      setErrors({});
    } else {
      setErrors(newErrors);
    }

    if (dontValidate || Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);
      if (typeof callback === 'function') await callback();
    }

    setIsSubmitting(false);
  }

  function handleChange(e: React.FormEvent<EventTarget>) {
    e.persist();

    const target = e.target as HTMLInputElement;
    const { value, name } = target;

    const newValues = {
      ...values,
      [name]: value.trim()
    };

    setValues(newValues);

    if (errors[name]) {
      setErrors(validate(newValues));
    }
  }

  function handleManualChange(changes: any) {
    let newValues = values;

    for (const i in changes) {
      newValues = { ...newValues, [i]: changes[i].trim() };
    }

    setValues(newValues);
  }

  return {
    handleChange,
    handleManualChange,
    handleSubmit,
    values,
    errors
  };
}
